export default __webpack_public_path__ + "static/media/LO10.481c7fb6.mp3";